/**
 * @generated SignedSource<<1179c587092b3c2282e6ab2a2fb3cd0e>>
 * @relayHash 90a80b4181f89b5f52bd889449d699b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 701fb74d1747c193510873223240f91465374fe4d7db89f32995a8b201acd557

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BusinessSummarySpaAppsQuery } from './BusinessSummarySpaAppsQuery.graphql';

const node: PreloadableConcreteRequest<BusinessSummarySpaAppsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "701fb74d1747c193510873223240f91465374fe4d7db89f32995a8b201acd557",
    "metadata": {},
    "name": "BusinessSummarySpaAppsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
